import './styles/main.scss';
import './scripts/menu';
import './scripts/sidebar';
import './scripts/listing';
import './scripts/tab-slider';
import './scripts/forms';

// Disable animations while resizing
let resizeTimer = null;

window.addEventListener('resize', () => {
  if (!resizeTimer) document.body.classList.add('resizing');
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove('resizing');
    resizeTimer = null;
  }, 500);
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}
